import { Stack, Typography, useTheme } from '@mui/material';

import { Strings } from '@app/constants';
import { AuthLayout } from '@app/layouts';
import { LoginForm } from './login-form';
import { SvgColor } from '@app/components/svg-color';

// ------------------------------------------------

const LoginPage = () => {
  const theme = useTheme();
  return (
    <AuthLayout title={Strings.header.login}>
      <Stack spacing={4} px={5}>
        <Typography variant="h3">
          {Strings.pageTitle.welcomeBack}
          <SvgColor
            src={`/assets/icons/ic_red_hat.svg`}
            sx={{ color: theme.palette.primary.main }}
          />
          <Typography color="text.secondary">{Strings.common.itsNiceToHaveYouBack}</Typography>
        </Typography>
        <Stack spacing={20}>
          <LoginForm />
        </Stack>
      </Stack>
    </AuthLayout>
  );
};

export { LoginPage };
